import React from 'react';
import { H2Alt } from 'scy/text';
import { mutedAccent } from 'scy/text/styles.mod.scss';
import {
  listTitle,
  listItem,
  zipCodeSection,
  zipCodeList
} from './styles.mod.scss';

export default function ZipCodes({ zipCodes }) {
  if (!zipCodes || !zipCodes.length) return null;

  return (
    <section className={zipCodeSection}>
      <H2Alt className={listTitle}>ZIP Codes We Deliver To</H2Alt>
      <ul className={zipCodeList}>
        {zipCodes.map(zipCode => (
          <li key={zipCode} className={`${mutedAccent} ${listItem}`}>
            {zipCode}
          </li>
        ))}
      </ul>
    </section>
  );
}
